export default function RecycleFilled() {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2622 7.29712C14.119 9.40404 13.9816 11.511 13.8443 13.6179C13.7249 15.4212 13.6055 17.2246 13.4802 19.028C13.4384 19.6113 13.1996 19.9327 12.7459 20.0457C12.6444 20.0696 12.5369 20.0696 12.4354 20.0696C9.34298 20.0696 6.25054 20.0696 3.16407 20.0696C2.53125 20.0696 2.17902 19.7184 2.13126 19.0875C1.97605 16.7663 1.81486 14.4452 1.65964 12.118C1.55218 10.5289 1.44472 8.9398 1.34323 7.35664C1.33129 7.19594 1.32532 7.02334 1.36114 6.8686C1.45666 6.41627 1.83874 6.14844 2.35812 6.14844C4.17299 6.14844 5.99383 6.14844 7.8087 6.14844H13.1936C13.9339 6.14844 14.31 6.55316 14.2622 7.29712Z"
        fill="#DA5A5C"
      />
      <path
        d="M15.212 1.79167V4.38663H0.501953V1.79762H3.88095V0.113281H11.7852V1.79167H15.212Z"
        fill="#DA5A5C"
      />
    </svg>
  )
}
